import {TimeCardStatusType} from '../../types/timecard-status.type';

/** Status transitions an admin may set from the current status. */
export function getAdminAllowedTransitions(currentStatus: TimeCardStatusType): TimeCardStatusType[] {
  switch (currentStatus) {
    case TimeCardStatusType.Closed:
    case TimeCardStatusType.Acknowledged:
      return [TimeCardStatusType.Approved, TimeCardStatusType.Archived];
    case TimeCardStatusType.Approved:
      return [TimeCardStatusType.Closed, TimeCardStatusType.Completed];
    default:
      return [];
  }
}
